import { API } from 'services/CommonService.jsx'

const ProjectAPI = {
  createProject: (data, callback) => {
    API.POST("/app/v1/project", data, (response) => {
      if (response.success) {
        callback({success: true});
      } else {
        callback({success: false, errors: response.errors });
      }
    });
  },
  selectProject: (projectId, callback) => {
    API.POST("/app/v1/user-project", {id: projectId}, (response) => {
      if (response.success) {
        callback({success: true});
      } else {
        callback({success: false, errors: response.errors });
      }
    });
  }
}

export { ProjectAPI }



// WEBPACK FOOTER //
// ./src/services/ApiService.jsx